
import "@/styles/pages/iosDataRecovery/index.css";
import registerViewer from "@/components/viewer";
import registerVideoViewer from "@/components/videoViewer";
import registerOpenVideo from "@/components/openVideo";
import registerSlider from "/framework/components/slider";
import registerFit from "@/components/fit";
import registerLearnMore from "@/components/learnMorePackUp";
import registerOurDomain from "@/components/ourDomain";
import registerMouseScrollDownDiv from "@/components/mouseSCrollDownDiv";
import registerPainting from "@/components/painting";
import registerTab from "@/components/tab";
import registerRecovery from "@/components/tabRecovery";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // /iphone-data-recover
// /iphone-data-recover.php

new Vue({
  created($, apower, LazyLoad) {
    registerOurDomain($, apower);
    $.register = $.registerComponent;
    window.apowerTrans = window.$apTranslations;
    window.apower = apower;
    apower.agents = {};
    registerMouseScrollDownDiv($, apower);
    registerOpenVideo($, apower);
    registerViewer($, apower);
    registerVideoViewer($, apower);
    registerSlider($, apower);
    registerFit($, apower);
    registerLearnMore($, apower);
    registerPainting($, apower);
    registerTab($, apower);
    registerRecovery($, apower);
  },
});

          })
        